import React from 'react'
import { Link } from '@inertiajs/react'
import { Chip } from '@mui/material'
import FavoriteIcon from '@mui/icons-material/Favorite'

interface Props {
  group: { id: number; name: string }
  size?: 'small' | 'medium'
  withIcon?: boolean
  onDelete?: () => void
}

export default function GroupChip({ group, size = 'small', withIcon = true, onDelete }: Props) {
  return (
    <Chip
      component={Link}
      href={`/groups/${group.id}`}
      clickable
      label={group.name}
      size={size}
      icon={withIcon ? <FavoriteIcon sx={{ fontSize: 14, color: 'inherit !important' }} /> : undefined}
      onDelete={onDelete}
      sx={{
        backgroundColor: 'secondary.main',
        color: 'primary.dark',
        fontWeight: 600,
        '& .MuiChip-icon': { color: 'primary.main', ml: 0.5 },
        '&:hover': { backgroundColor: 'rgba(123, 91, 214,0.18)' },
      }}
    />
  )
}
